export default {
  agentId: null,
  customerId: null,
  customerUrl: null,
  id: null,
  isAgentTyping: null,
  isSynced: null,
  lastMessage: null,
  localCreatedAt: null,
  metadata: null,
  unreadCount: 0,
  status: null,
  welcomeMessage: null,
};
